import React from "react"
import tw, { css } from "twin.macro"
import htmlFilters from "../../../helpers/htmlFilters";

const BlogTexto = ({ content }) => {
  return (
    <div
      css={estilosParrafoBlog}
    >{htmlFilters(content.data.texto_con_formato1)}</div>
  )
}

const estilosParrafoBlog = css`
  ${tw`text-gris1 dark:text-gris4 mt-4`}
  font-size: 1rem;
  line-height: 1.68;
  & p {
    ${tw`font-light mb-4`}
  }
  p.blog_intro,
  .blog_intro {
    ${tw`text-2xl leading-14em md:text-3xl md:leading-15em`}
  }
  p.blog_subtitulo,
  .blog_subtitulo {
    ${tw`text-obmed3 font-semibold my-3 md:text-2xl md:my-4`}
    & strong {
      ${tw`font-semibold`}
    }
  }
  p.blog_destacado,
  .blog_destacado {
    ${tw`text-obmed3 leading-16em my-8 pl-5 md:text-2xl md:my-12 md:pl-14 md:leading-17em`}
  }
  & strong {
    ${tw`font-semibold`}
  }
  & a {
    ${tw`underline`}
    ${tw`text-marron1`}
  }
  ul,
  ol{
    ${tw`font-obbody mb-4 pl-5  md:pl-14`}
  }
  ul{
    ${tw`list-disc`}
  }
  ol{
    ${tw`list-decimal`}
  }
  li{
    ${tw`my-2 md:my-2`}
  }
`

export default BlogTexto
